<lucide-icon
  [name]="name()"
  [size]="size()"
  [strokeWidth]="strokeWidth()"
  [color]="color()"
  [ngClass]="customClass()"
  (click)="clicked.emit()"
/>
